import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Logger } from '@nsalaun/ng-logger';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { Context } from '../../context/models/context.model';
import { DefaultUserTokenClaims } from '../../context/models/user-token-claims.model';
import { ContextService } from '../../context/services/context.service';

@Injectable({ providedIn: 'root' })
export class IsNotLoggedInGuard<T extends Context, U extends DefaultUserTokenClaims> {
	private contextService = inject<ContextService<T, U>>(ContextService);
	private router = inject(Router);
	private logger = inject(Logger);

	canActivate(): Observable<boolean> {
		return this.contextService.getFirstContext().pipe(
			map((context: T | null) => context.isNotLoggedInState()),
			tap((canActivate: boolean) => {
				if (!canActivate) {
					this.router.navigateByUrl('/').catch((error) => {
						this.logger.error('Navigation failed', error);
					});
				}
			}),
		);
	}
}
